import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  Container,
  Divider,
  Label,
  Segment,
  Table
} from 'semantic-ui-react';
import axios from 'axios';

import CommandConfig from '../components/CommandConfig';
import { useAuth, useError } from '../providers';

const Commands = () => {
  const [commands, setCommands] = useState({});
  const [refresh, setRefresh] = useState(0);
  const { showError } = useError();
  const { user } = useAuth();

  useEffect(() => {
    const getCommands = async (user) => {
      try {
        const { data }  = await axios(
          `/api/commands/${user}`,
        );
        if (data.status === 200) {
          setCommands(data.response.commands);
        }
      } catch(err) {
        showError(<center>Oops, something went wrong. Don't worry, we've been notified of the issue and will fix it as soon as possible!</center>);
      }
    }

    if (user['username']) {
      getCommands(user['username']);
    }
  }, [user, refresh, showError]);

  const refreshCommands = () => {
    setRefresh(value => value + 1);
  }

  return (
    <Segment className='lobby' inverted>
      <Container text className='description'>
        <Breadcrumb size='huge'>
          <Breadcrumb.Section link as={Link} to='/dashboard'>Dashboard</Breadcrumb.Section>
          <Breadcrumb.Divider icon='right chevron' />
          <Breadcrumb.Section active>Commands</Breadcrumb.Section>
        </Breadcrumb>
        <Divider hidden />
        <p>
          While you can manage basic availability options of commands within the mod, this page provides advanced customization of commands, such as managing the rate limits, and banning items.
        </p>
      </Container>
      <Table celled compact definition inverted>
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan={3}>
              Command
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Object.values(commands).map((command, index) =>
          <React.Fragment>
            {command.is_custom ? '' :
            <Table.Row key={index}>
              <Table.Cell style={{ "position": "relative" }}>
                <strong>
                  {command.syntax}
                  {Object.values(command.params).map((param, index) => <em>&nbsp;[{param.name}]</em>)}
                </strong>
                <br />
                {command.description ? command.description : ''}
                <div style={{
                  "position": "absolute",
                  "right": "5px",
                  "top": "5px",
                }}>
                { command.flags === 0 ? <React.Fragment><Label color='red' size='mini'>Disabled</Label></React.Fragment> : ''}
                { command.flags & 1 ? <React.Fragment><Label color='green' size='mini'>Enabled</Label></React.Fragment> : ''}
                { command.flags & 2 ? <React.Fragment><Label color='grey' size='mini'>Sub Only</Label></React.Fragment> : ''}
                { command.is_alias ? <React.Fragment><Label color='orange' size='mini'>Alias</Label></React.Fragment> : ''}
                </div>
              </Table.Cell>
              <Table.Cell collapsing>
                <CommandConfig key={command.command} command={command} refresh={refreshCommands} /*type="global"*/ />
              </Table.Cell>
            </Table.Row>
            }
          </React.Fragment>
          )}
        </Table.Body>
      </Table>
    </Segment>
  )
};

export default Commands;
